/**
 * Context for offline POS state (desktop app only).
 * Provides pending bill count and sync actions for the sync indicator.
 */

import React, { createContext, useContext } from 'react';

export const OfflineContext = createContext({
  pendingCount: 0,
  isSyncing: false,
  syncNow: () => {},
  refreshPendingCount: () => {},
  fetchPendingOrders: () => Promise.resolve([]),
  deleteOfflineOrder: () => Promise.resolve(),
  /** After saving an offline bill: refresh badge & allow immediate reconcile (no extra wait for throttle). */
  kickOfflineReconcile: () => {},
});

export function useOffline() {
  return useContext(OfflineContext);
}
